/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-new */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  SetStateAction,
} from "react";
import {
  makeStyles,
  createTheme,
  Grid,
  List,
  ListItem,
  ListItemText,
  Collapse,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Switch,
  ThemeProvider,
  Typography,
  Divider,
  TextField,
  IconButton,
  Button,
  Table,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Container,
  SwitchProps,
  ListItemIcon,
  Tooltip,
} from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore,
  UnfoldLess,
  Delete,
  Edit,
  CheckBox,
  Check,
} from "@material-ui/icons";
import {
  StylesProvider,
  createGenerateClassName,
  styled,
} from "@material-ui/core/styles";
import style from "./styles/Settings.module.css"

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#0684bd',
        opacity: 1,
        border: 0,
        // ...theme.applyStyles('dark', {
        //   backgroundColor: '#2ECA45',
        // }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      // ...theme.applyStyles('dark', {
      //   color: theme.palette.grey[600],
      // }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      // ...theme.applyStyles('dark', {
      //   opacity: 0.3,
      // }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    // ...theme.applyStyles('dark', {
    //   backgroundColor: '#39393D',
    // }),
  },
}));


const generateClassName = createGenerateClassName({
  productionPrefix: "settings",
});

const myTheme = createTheme({
  palette: {
    primary: {
      main: "#0684BD",
    },
    secondary: {
      main: "#ff8c00",
    },
  },
});

const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#D3D3D3",
    },
    secondary: {
      main: "#ff8c00",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  // style for light
  body: {
    backgroundColor: "white",
    color: "black",
    fontFamily: "roboto",
    // fontSize: "0.875rem",
  },
  switchBase: {},
  radioButton: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  radioText: {
    fontSize: "0.875rem",
  },
  radio: {
    color: "gray",
    "&.Mui-checked": {
      color: "#ff8c00",
    },
  },
  fontSize: {
    "& span:last-child": {
      // fontSize: "0.875rem",
    },
  },
  listItem: {
    fontWeight: "bold",
  },
  list: {
    paddingLeft: 20,
  },
  typography: {
    color: "black",
  },
  dialog: {},
  table: {
    minWidth: 650,
  },
}));

const useDarkStyles = makeStyles((theme) => ({
  body: {
    backgroundColor: "rgb(40, 40, 40) !important",
    color: "white",
    fontFamily: "Roboto, sans-serif",
    // fontSize: "0.875rem",
  },
  switchBase: {
    color: "gray",
  },
  radioButton: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  radioText: {
    fontSize: "0.875rem",
  },
  radio: {
    color: "white",
    "&.Mui-checked": {
      color: "#ff8c00",
    },
  },
  fontSize: {
    "& span:last-child": {
      // fontSize: "0.875rem",
    }
  },
  listItem: {
    fontWeight: "bold",
  },
  list: {
    paddingLeft: 20,
  },
  typography: {
    color: "white",
  },
  dialog: {
    backgroundColor: "rgb(40, 40, 40) !important",
    color: "white",
  },
  table: {
    minWidth: 650,
  },
}));



declare global {
  interface Window {
    googleTranslateElementInit: () => void;
  }
}

window.googleTranslateElementInit = function () {
  if ((window as any).google?.translate) {
    new (window as any).google.translate.TranslateElement(
      { pageLanguage: "en" },
      "settings_translate_element"
    );
  } else {
    console.error("Google Translate library not loaded");
  }
};



function Settings({
  setChangeTab,
  id,
  origin,
  mode,
  rcId,
  changeTab,
  lastCode,
  showLeaderboards,
  elapsedTime,
  setElapsedTime,
  hasPresenceTimer,
  hasInvisibleCallControl,
  idToken,
  forwardAddress,
  showCherryPick,
  deviceId,
  rcAccessToken,
  setDeviceId,
  setShowCherryPick,
  queueCallPickUp,
  updateLocal,
  setShowCXLeaderboards,
  showCXLeaderboards,
  cxEnabled,
  setShowLeaderboards,
  setMode,
  legacyUI,
  setLegacyUI,
  orgId,
}: {
  id: string;
  origin: string;
  mode: string;
  rcId: string;
  changeTab: string | undefined;
  lastCode: string | undefined;
  showLeaderboards: boolean | undefined;
  setChangeTab: React.Dispatch<SetStateAction<string>>;
  setShowCXLeaderboards: React.Dispatch<SetStateAction<boolean | undefined>>;
  showCXLeaderboards: boolean | undefined;
  elapsedTime: string;
  setElapsedTime: any;
  hasPresenceTimer: boolean;
  hasInvisibleCallControl: boolean;
  idToken: string;
  forwardAddress: string;
  showCherryPick: boolean | undefined;
  deviceId: string | undefined;
  rcAccessToken: string | undefined;
  setDeviceId: any;
  setShowCherryPick: any;
  queueCallPickUp: boolean;
  updateLocal: any;
  cxEnabled: boolean;
  setShowLeaderboards: any;
  setMode: any;
  legacyUI: boolean;
  setLegacyUI: React.Dispatch<SetStateAction<boolean>>;
  orgId: string;
}) {
  const [openDisplaySettings, setOpenDisplaySettings] = useState(false);
  const [openCallHandling, setOpenCallHandling] = useState(false);
  const [openCX, setOpenCX] = useState(false);
  const [openEX, setOpenEX] = useState(false);
  const [hover, setHover] = useState<string | boolean>(false)
  const [tab, setTab] = useState<"display" | "EX" | "CX">("display")

  const [invisibleCallControl, setInvisibleCallControl] = useState<string>("");
  // const [selectedDevice, setSelectedDevice] = useState<string | undefined>();
  const [myDevices, setMyDevices] = useState<
    | Array<{
        id: string;
        type?: string;
        name?: string;
        serial?: string;
        status?: string;
      }>
    | undefined
  >();
  const [error, setError] = useState<string | undefined>();
  const deviceRef = useRef<HTMLInputElement>(null);

  const classes = mode === "light" ? useStyles() : useDarkStyles();
  document.body.className = classes.body;

  useEffect(() => {
    if (elapsedTime === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-elapsedTime`, elapsedTime);
  }, [elapsedTime]);


  // // used to apply a google translate dropdown box. TODO: ,ake styles
  // useEffect(() => {
  //     window.googleTranslateElementInit = function () {
  //       new (window as any).google.translate.TranslateElement(
  //         { pageLanguage: "en" },
  //         "settings_translate_element"
  //       );
  //     };
  //     const scriptId = "google-translate-script2";
  //     if (!document.getElementById(scriptId)) {
  //       const script = document.createElement("script");
  //       script.id = scriptId;
  //       script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //       script.async = true;
  //       document.body.appendChild(script);
  //     }
  // }, []);


  useEffect(() => {
    const cxLeaderboardsFromStorage = localStorage.getItem(
      "cx-leaderboards-visible"
    );
    if (!cxLeaderboardsFromStorage) {
      setShowCXLeaderboards(true);
      localStorage.setItem("cx-leaderboards-visible", JSON.stringify(true));
    }
    if (cxLeaderboardsFromStorage) {
      setShowCXLeaderboards(JSON.parse(cxLeaderboardsFromStorage));
    }
  }, []);
  useEffect(() => {
    if (!hasInvisibleCallControl) {
      return;
    }

    (async () => {
      const { invisibleCallControl: newCallControl } = (await fetch(
        forwardAddress.replace("/shadow-agent", `/user/${rcId}`),
        {
          method: "get",
          headers: {
            Authorization: idToken,
          },
        }
      ).then((res) => res.json())) as {
        invisibleCallControl: string | undefined;
      };

      setInvisibleCallControl(newCallControl || "");
    })();
  }, [idToken]);

  const getDeviceList = useCallback(async () => {
    if (rcAccessToken === undefined) {
      setError("No access token.");
      return;
    }
    try {
      const { records } = await fetch(
        "https://platform.ringcentral.com/restapi/v1.0/account/~/extension/~/device",
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${rcAccessToken}`,
          },
        }
      ).then((response) => response.json());

      setMyDevices(records);
    } catch (err) {
      console.log(err);
      setError("Request Error. Please try again later.");
    }
  }, [rcAccessToken]);

  useEffect(() => {
    if (showCherryPick) {
      return;
    }

    setMyDevices(undefined);
  }, [showCherryPick]);

  useEffect(() => {
    if (showCherryPick !== true) {
      return;
    }
    getDeviceList();
  }, [showCherryPick]);

  const changeDeviceId = useCallback(
    async (selectedDevice) => {
      if (selectedDevice !== deviceId) {
        try {
          const { status } = await fetch(
            forwardAddress.replace("/shadow-agent", `/device/user/${rcId}`),
            {
              method: "put",
              headers: {
                authorization: idToken,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                deviceId: selectedDevice,
              }),
            }
          );

          if (status === 200) {
            setDeviceId(selectedDevice);
          } else {
            throw Error();
          }
        } catch (err) {
          setError("Couln't change device id. Please try again later.");
        }
      }
    },
    [deviceId, rcId, idToken]
  );

  useEffect(() => {
    if (showCherryPick === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-showCherryPick`,
      showCherryPick.toString()
    );
  }, [showCherryPick, updateLocal]);

  // const saveCherryPickPreference = useCallback(
  //   async (newValue: boolean) => {
  //     try {
  //       const { status } = await fetch(
  //         forwardAddress.replace("/shadow-agent", `/settings/user/${rcId}`),
  //         {
  //           method: "put",
  //           headers: {
  //             authorization: idToken,
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             key: "showCherryPick",
  //             value: newValue,
  //           }),
  //         }
  //       );

  //       if (status === 200) {
  //         setShowCherryPick(newValue);
  //       } else {
  //         throw Error();
  //       }
  //     } catch (err) {
  //       setError("Something went wrong. Please try again.");
  //     }
  //   },
  //   [rcId, idToken]
  // );
  // useEffect(() => {
  //   if (selectedDevice === undefined) {
  //     return;
  //   }
  //   saveDeviceId();
  // }, [selectedDevice, saveDeviceId]);

  // const handleCloseError = useCallback(() => setError(undefined), []);

  const lightMode = mode === "light";

  const handleElapsedTimeDisplay = (time: string): void => {
    localStorage.setItem(`elapsed-time-display-${rcId}`,time);
    setElapsedTime(time)
  }
  const handleInvisibleCallControll = (event: string): void => {
    const updateUser = async (newCallControl: string) => {
      setInvisibleCallControl(newCallControl);
      await fetch(
        forwardAddress.replace("/shadow-agent",`/user/${rcId}`),
        {
          method: "put",
          headers: {
            Authorization: idToken,
          },
          body: JSON.stringify({
            invisibleCallControl:
              newCallControl || undefined,
          }),
        }
      );
    };
    updateUser(event);
}

  return !legacyUI ? (
      <Container maxWidth="lg" className={style.container} style={{height:  'calc(100vh - 70px)', paddingTop: 30, borderRadius: 15}}>
        <Grid container spacing={4} style={{height: '100%', borderRadius: 15}} className={style.grid}>
        {/* LEFT SIDE */}
        <Grid item xs={12} md={4} lg={4} xl={4} className={style.gridInner}>
          <button style={tab === "display" ? {background: lightMode ? "#2196f31a" : "#161616", color: lightMode ? "#0081b5" :""} : {}} type="button" onClick={() => setTab('display')} className={lightMode ? style.settingsSelectorButton : style.settingsSelectorButtonDark}>Display</button>
          <button style={tab === "EX" ? {background: lightMode ? "#2196f31a" : "#161616", color: lightMode ? "#0081b5" : ""} : {}} type="button" onClick={() => setTab("EX")} className={lightMode ? style.settingsSelectorButton : style.settingsSelectorButtonDark}>{cxEnabled ? "EX" : "Call Handling"}</button>
          {cxEnabled && <button style={tab === "CX" ? {background: lightMode ? "#2196f31a" : "#161616", color: lightMode ? "#0081b5" :""} : {}} type="button" onClick={() => setTab("CX")} className={lightMode ? style.settingsSelectorButton : style.settingsSelectorButtonDark}>CX</button>}
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} md={8} lg={8} xl={8} className={style.rightGrid} style={{background: lightMode ? '#f5f5f5': "#161616", borderRadius: '0.5rem', overflow: "scroll", maxHeight: "calc(100vh - 100px)"}}>
          {
            tab === 'display' && (
            <>
              <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                <ListItemText primary="Dark Mode" />
                <IOSSwitch
                  checked={mode === "dark"}
                  onChange={() => {
                    localStorage.setItem("theme" , mode === 'light' ? "dark" : "light")
                    setMode((p: string | undefined) => p === 'light' ? "dark" : "light")
                  }
                  }
                />
              </ListItem>                                           
              {(orgId === "3154756020" || orgId === "1520397020" || orgId === "63002203008") && (
                <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                  <ListItemText primary="Display Legacy UI" />
                  <IOSSwitch
                    checked={legacyUI}
                    onChange={() => setLegacyUI((prev: any) => !prev)}
                  />
                </ListItem>
              )}
              {
                !cxEnabled && (
                  <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                  {/* <ListItemIcon>
                    <Group />
                  </ListItemIcon> */}                        
                  <ListItemText primary="Show Leaderboards" />
                  <IOSSwitch
                    size="small"
                      checked={showLeaderboards}
                      onClick={() =>
                        window.parent.postMessage(
                          JSON.stringify({
                            showLeaderboards: !showLeaderboards,
                            event: "show-leaderboards",
                          }),
                          origin
                        )
                      }
                  />
                </ListItem>
                )
              }
              {hasPresenceTimer && (
                <>
                <div className={lightMode ? style.itemHelperText : style.itemHelperTextDark}>Elapsed Time Display</div>
                  <div className={style.settingsItemRadioContainer}>
                    <ListItem 
                    onClick={() => handleElapsedTimeDisplay('none')}  
                    className={lightMode ? style.settingsItemRadio :style.settingsItemRadioDark}>
                      <ListItemIcon>
                        {elapsedTime === "none" && <Check style={{color: "#0684bd"}} />}
                      </ListItemIcon>
                      <ListItemText
                        primary="none"
                      />
                    </ListItem>
                    <ListItem
                     onClick={() => handleElapsedTimeDisplay('full')} 
                     className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                    <ListItemIcon>
                      {elapsedTime === "full" && <Check style={{color: "#0684bd"}} />}
                    </ListItemIcon>
                    <ListItemText
                      primary="full"
                    />
                  </ListItem>
                    <ListItem onClick={() => handleElapsedTimeDisplay('approximate')} className={lightMode ? style.settingsItemRadio :style.settingsItemRadioDark}>
                    <ListItemIcon>
                      {elapsedTime === "approximate" && <Check style={{color: "#0684bd"}} />}
                    </ListItemIcon>
                    <ListItemText
                      primary="approximate"
                    />
                  </ListItem>
                    <ListItem
                    onClick={() => handleElapsedTimeDisplay('daily')}
                    className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                    <ListItemIcon>
                      {elapsedTime === "daily" && <Check style={{ color: "#0684bd" }} />}
                    </ListItemIcon>
                    <ListItemText
                      primary="daily"
                    />
                  </ListItem>
                  </div>
                </>
              )}
            </>
            )
          }
          {
            tab === "EX" && (
            <>
              { cxEnabled && 
                <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                  {/* <ListItemIcon>
                    <Group />
                  </ListItemIcon> */}                        
                  <ListItemText primary="Show Leaderboards" />
                  <IOSSwitch
                    size="small"
                      checked={showLeaderboards}
                      onClick={() =>
                        window.parent.postMessage(
                          JSON.stringify({
                            showLeaderboards: !showLeaderboards,
                            event: "show-leaderboards",
                          }),
                          origin
                        )
                      }
                  />
                </ListItem>
              }
                    {changeTab !== undefined && (
                         <>
                         <div className={lightMode ? style.itemHelperText : style.itemHelperTextDark}>Call Log Tab On Call</div>
                          <div className={style.settingsItemRadioContainer}>
                            <ListItem className={lightMode ? style.settingsItemRadio :style.settingsItemRadioDark}>
                              <ListItemText primary="Inbound" />
                              <IOSSwitch
                                checked={changeTab === "Enabled" ||changeTab === "Inbound"}
                                onMouseDown={(event: any) => {
                                  let newValue;
                                  if (event.target.checked) {
                                    if (changeTab === "Outbound") {
                                      newValue = "Enabled"
                                    }
                                    if (changeTab === "Enabled") {
                                      newValue = "Outbound"
                                    }
                                  } else {
                                    if (changeTab === "Disabled") {
                                      newValue = "Inbound"
                                    }
                                    if (changeTab === "Outbound") {
                                      newValue = "Enabled"
                                    }
                                  }
                                  setChangeTab(newValue || "Disabled")
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      changeTab: newValue,
                                      event: "flip-on-call",
                                    }),
                                    origin
                                  );
                                }}
                              />
                            </ListItem>
                            <ListItem                      
                            className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                              <ListItemText primary="Outbound" />
                              <IOSSwitch
                                checked={
                                  changeTab === "Enabled" ||
                                  changeTab === "Outbound"
                                }
                                onClick={(event: any) => {
                                  let newValue;
                                  if (event.target.checked) {
                                    if (changeTab === "Disabled") {
                                      newValue = "Outbound";
                                    }

                                    if (changeTab === "Inbound") {
                                      newValue = "Enabled";
                                    }
                                  } else {
                                    if (changeTab === "Outbound") {
                                      newValue = "Disabled";
                                    }

                                    if (changeTab === "Enabled") {
                                      newValue = "Inbound";
                                    }
                                  }
                                  setChangeTab(newValue || "Disabled")
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      changeTab: newValue,
                                      event: "flip-on-call",
                                    }),
                                    origin
                                  );
                                }}
                              />
                            </ListItem>
                      </div>
                     </>
                      )}
                      {lastCode !== undefined && (
                        <>
                        <div className={lightMode ? style.itemHelperText : style.itemHelperTextDark}>Forced Account Codes</div>
                          <div className={style.settingsItemRadioContainer}>
                            <ListItem 
                            onClick={() =>
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      lastCode: "No Suggestion",
                                      event: "last-code",
                                    }),
                                    origin
                                  )
                                }  
                            className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                              <ListItemIcon>
                                {lastCode === "No Suggestion" && <Check style={{color: "#0684bd"}} />}
                              </ListItemIcon>
                              <ListItemText
                                primary="No Suggestion"
                              />
                            </ListItem>
                            <ListItem
                             onClick={() =>
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      lastCode: "Suggest Last Code",
                                      event: "last-code",
                                    }),
                                    origin
                                  )
                                }  
                              className={ lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                            <ListItemIcon>
                              {lastCode === "Suggest Last Code" && <Check style={{color: "#0684bd"}} />}
                            </ListItemIcon>
                            <ListItemText
                              primary="Suggest Last Code"
                            />
                          </ListItem>
                            <ListItem 
                            onClick={() =>
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      lastCode: "Suggest Last Code for Number",
                                      event: "last-code",
                                    }),
                                    origin
                                  )
                                }  className={ lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                            <ListItemIcon>
                              {lastCode === "Suggest Last Code for Number" && <Check style={{color: "#0684bd"}} />}
                            </ListItemIcon>
                            <ListItemText
                              primary="Suggest Last Code for Number"
                            />
                          </ListItem>
                          </div>
                        </>
                      )}
                      {hasInvisibleCallControl && (
                        <>
                        <div className={lightMode ? style.itemHelperText : style.itemHelperTextDark}>When I am Invisible</div>
                          <div className={style.settingsItemRadioContainer}>
                            <ListItem 
                            onClick={() => {
                                  const updateUser = async (newCallControl: string) => {
                                    setInvisibleCallControl("");
                                    await fetch(forwardAddress.replace("/shadow-agent",`/user/${rcId}`),
                                      {
                                        method: "put",
                                        headers: {
                                          Authorization: idToken,
                                        },
                                        body: JSON.stringify({
                                          invisibleCallControl: "takeNoAction"
                                        }),
                                      }
                                    );
                                  };
                                  updateUser("");
                                }}  
                            className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                              <ListItemIcon>
                                {invisibleCallControl === "" && <Check style={{color: "#0684bd"}} />}
                              </ListItemIcon>
                              <ListItemText
                                primary="Take No Action"
                              />
                            </ListItem>
                            <ListItem
                              onClick={() => {
                                const updateUser = async (newCallControl: string) => {
                                    setInvisibleCallControl(newCallControl);
                                    await fetch(forwardAddress.replace("/shadow-agent",`/user/${rcId}`),
                                      {
                                        method: "put",
                                        headers: {
                                          Authorization: idToken,
                                        },
                                        body: JSON.stringify({
                                          invisibleCallControl:
                                            newCallControl || undefined,
                                        }),
                                      }
                                    );
                                  };
                                  updateUser("TakeAllCalls");
                              }} 
                              className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                            <ListItemIcon>
                              {invisibleCallControl === "TakeAllCalls" && <Check style={{color: "#0684bd"}} />}
                            </ListItemIcon>
                            <ListItemText
                              primary="Take All Calls"
                            />
                          </ListItem>
                            <ListItem onClick={() => {
                                const updateUser = async (newCallControl: string) => {
                                    setInvisibleCallControl(newCallControl);
                                    await fetch(forwardAddress.replace("/shadow-agent",`/user/${rcId}`),
                                      {
                                        method: "put",
                                        headers: {
                                          Authorization: idToken,
                                        },
                                        body: JSON.stringify({
                                          invisibleCallControl:
                                            newCallControl || undefined,
                                        }),
                                      }
                                    );
                                  };
                                  updateUser("DoNotAcceptDepartmentCalls");
                              }} className={lightMode ? style.settingsItemRadio : style.settingsItemRadioDark}>
                            <ListItemIcon>
                              {invisibleCallControl === "DoNotAcceptDepartmentCalls" && <Check style={{color: "#0684bd"}} />}
                            </ListItemIcon>
                            <ListItemText
                              primary="Do Not Accept Queue Calls"
                            />
                          </ListItem>
                          </div>
                          </>
               
                      )}
                      {queueCallPickUp && (
                        <>
                        
                        <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                          {/* <ListItemIcon>
                            <Group />
                          </ListItemIcon> */}                        
                          <ListItemText primary="Cherry Pick" />
                          <IOSSwitch
                            size="small"
                              checked={showCherryPick}
                              onClick={() => {
                                setShowCherryPick(
                                  (oldShowCherryPick: boolean | undefined) =>
                                    !oldShowCherryPick
                                );
                              }
                              }
                          />
                        </ListItem>

                          {error !== undefined && (
                            <ListItem style={{ paddingLeft: 40 }}>
                              <ListItemText
                                style={{ color: "red" }}
                                primary={`${error}`}
                              />
                            </ListItem>
                          )}
                        
                          {myDevices && myDevices.length === 0 && (
                            <div className={lightMode ? style.queueHelperText : style.queueHelperTextDark} style={{marginTop: 5, marginLeft: 10}}>
                              You do not have any devices enabled.
                            </div>
                          )}
                          {myDevices && myDevices.length > 0 && (
                            <div className={style.settingsItemRadioContainer}>
                              <div className={lightMode ? style.itemHelperText : style.itemHelperTextDark} style={{marginTop: 5, marginLeft: 10}}>
                          Select a device below. {myDevices && myDevices?.length || "0"} Device(s) available.
                              </div>
                              {[...myDevices].map((device) => {
                                const isOnline = device.status?.toLowerCase() === "online";
                                const isSelected = deviceId === device.id;

                                return (
                                  <div
                                    key={device.id}
                                    role="button"
                                    tabIndex={0}
                                    onMouseEnter={() => setHover(device.id)}
                                    onMouseLeave={() => setHover(false)}
                                    onClick={() => changeDeviceId(device.id)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        changeDeviceId(device.id);
                                      }
                                    }}
                                    className={lightMode ? style.settingsCherryPickItem : style.settingsCherryPickItemDark}

                                    style={{
                                      padding: "10px 15px",
                                      display: "flex",
                                      alignItems: "center",
                                      filter: device.id === hover ? "brightness(1.1)" : "",
                                      background: isSelected ? "1px solid #0684bd" : undefined,
                                      boxShadow: isSelected ? "0 0 2px rgba(6, 132, 189, 0.2)" : undefined,
                                      outline: "none",
                                    }}
                                    >
                                      {/* Status Indicator */}
                                      <Tooltip
                                      title={<h2>{isOnline ? "Device Online" : "Device Offline"}</h2>}
                                        placement="top"
                                        arrow
                                      >
                                      <div
                                        style={{
                                          width: 16,
                                          height: 16,
                                          borderRadius: "50%",
                                          backgroundColor: isOnline ? "#4caf50" : "#f44336",
                                          marginRight: 10,
                                          border: isSelected ? "2px solid #0684bd" : "2px solid transparent",
                                          flexShrink: 0,
                                        }}
                                      />
                                    </Tooltip>
                                      {/* Device Info */}
                                      <div style={{ flexGrow: 1 }}>
                                        <div style={{ 
                                          fontWeight: isSelected ? 600 : 400, 
                                          color: lightMode ? "#333" : "#fff" 
                                          }}>
                                            {device.name || "Unnamed Device"}
                                        </div>
                                        <div style={{
                                          fontSize: "0.8rem",
                                          color: lightMode ? "#666" : "#aaa",
                                          marginTop: 2,
                                        }}>
                                          {device.serial || "No Serial"} - {device.type || "Unknown Type"}
                                        </div>
                                      </div>
                                      {/* Selected Checkmark */}
                                      {isSelected && (
                                        <Check style={{
                                          color: "#0684bd",
                                          marginLeft: 10,
                                          flexShrink: 0,
                                        }} />
                                      )}
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                              {/* {[...myDevices].map((device) => (
                                <>
                                <ListItem 
                                  onMouseEnter={() => setHover(device.id)}
                                  onMouseLeave={() => setHover(false)}
                                  onClick={() => changeDeviceId(device.id)}  
                                  className={lightMode ? style.settingsCherryPickItem : style.settingsCherryPickItemDark} style={{filter: device.id === hover ? "brightness(1.1)" : ""}}>
                                    <ListItemIcon>
                                      {deviceId === device.id && <Check style={{color: "#0684bd"}} />}
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={
                                      <>
                                       <TableContainer >
                                      <Table
                                        size="small"
                                        aria-label="a dense table"
                                        style={{
                                          background:
                                            mode === "light"
                                              ? "white"
                                              : "#252525",
                                          color:
                                            mode === "light"
                                              ? "black"
                                              : "white",
                                          borderRadius: 4,
                                        }}
                                      >
                                        <TableBody style={{border:0}}>
                                          <TableRow>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              Id
                                            </TableCell>
                                            <TableCell
                                            className="notranslate"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                              align="right"
                                            >
                                              {device.id}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              Type
                                            </TableCell>
                                            <TableCell
                                            className="notranslate"
                                              align="right"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              {device.type || ""}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              Name
                                            </TableCell>
                                            <TableCell
                                            className="notranslate"
                                              align="right"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              <span className="notranslate">{device.name || ""}</span>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                              component="th"
                                              scope="row"
                                            >
                                              Serial
                                            </TableCell>
                                            <TableCell
                                            className="notranslate"
                                              align="right"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              {device.serial || ""}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                              component="th"
                                              scope="row"
                                            >
                                              Status
                                            </TableCell>
                                            <TableCell
                                            className="notranslate"
                                              align="right"
                                              style={{
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderBottom:
                                                  mode === "light"
                                                    ? "1px solid #33333311"
                                                    : "1px solid #5e5e5e24",
                                              }}
                                            >
                                              {device.status || ""}
                                            </TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                      </>
                                      }
                                    />
                                  </ListItem>
                                </>
                              ))} */}
                            {/* </div>
                          )} */}
                   
                        </>
                      )}
            </>
                 
            )
          }
          {
            tab === "CX" && (
                <ListItem className={lightMode ? style.settingsItem : style.settingsItemDark}>
                <ListItemText primary="Show Leaderboards" />
                  <IOSSwitch
                    size="small"
                    checked={showCXLeaderboards}
                    onChange={() => {
                    localStorage.setItem(
                      "cx-leaderboards-visible",
                      JSON.stringify(!showCXLeaderboards)
                    );
                    setShowCXLeaderboards((p: any) => !p);
                  }}
              />
            </ListItem>
            )
          }
        </Grid>
      </Grid>
      </Container>
    ) : <>
      {cxEnabled ? (
        <ThemeProvider theme={mode === "light" ? myTheme : darkTheme}>
          <StylesProvider generateClassName={generateClassName}>
            {/* <Dialog
              classes={{ paper: classes.dialog }}
              open={error !== undefined}
              fullWidth
              onClose={handleCloseError}
              aria-labelledby="error-waiting-tab"
            >
              {" "}
              <DialogTitle id="error-waiting-tab">Error</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Typography
                    component="span"
                    style={{ fontSize: "0.8rem" }}
                    className={classes.typography}
                  >
                    {error}
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={handleCloseError}
                  color={mode === "dark" ? "default" : "primary"}
                  variant="contained"
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog> */}
            <Grid container spacing={0}>
              <Grid item sm={6} xs={12}>
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => setOpenDisplaySettings(!openDisplaySettings)}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: "bold" }}>
                          Display Settings
                        </Typography>
                      }
                      classes={{ root: classes.listItem }}
                    />
                    {openDisplaySettings ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse
                    in={openDisplaySettings}
                    timeout="auto"
                    unmountOnExit
                    style={{ marginLeft: 40 }}
                  >
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 10 }}
                      dense
                      classes={{ root: classes.list }}
                    >
                      <ListItem>
                        <ListItemText primary="Dark Mode" />
                        <Switch
                          classes={{ switchBase: classes.switchBase }}
                          color="secondary"
                          checked={mode === "dark"}
                          onChange={() => {
                           localStorage.setItem("theme" , mode === 'light' ? "dark" : "light")
                            setMode((p: string | undefined) => p === 'light' ? "dark" : "light")
                          }
                          }
                        />
                      </ListItem>
                      {(orgId === "3154756020" || orgId === "1520397020" || orgId === "63002203008") && (
                        <ListItem>
                          <ListItemText primary="Display Legacy UI" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={legacyUI}
                            onChange={() => setLegacyUI((prev: any) => !prev)}
                          />
                        </ListItem>
                      )}
                      {hasPresenceTimer && (
                        <>
                          <ListItem>
                            <ListItemText primary="Elapsed Time Display" />
                          </ListItem>
                          <ListItem>
                            <FormControl style={{ paddingLeft: 10 }}>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={elapsedTime}
                                name="radio-buttons-group"
                                onChange={(e) => {
                                  setElapsedTime(() => {
                                    localStorage.setItem(
                                      `elapsed-time-display-${rcId}`,
                                      e.target.value
                                    );
                                    return e.target.value;
                                  });
                                }}
                              >
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="none"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      None
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="full"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      Full
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="approximate"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      Approximate
                                    </Typography>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </ListItem>
                        </>
                      )}
                    </List>
                  </Collapse>

                  <ListItem
                    button
                    style={{ marginTop: 10 }}
                    onClick={() => setOpenEX(!openEX)}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: "bold" }}>
                          EX
                        </Typography>
                      }
                      classes={{ root: classes.listItem }}
                    />
                    {openEX ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse
                    in={openEX}
                    style={{ marginLeft: 40 }}
                    unmountOnExit
                  >
                    {showLeaderboards !== undefined && (
                      <ListItem>
                        <ListItemText primary="Show Leaderboards" />
                        <Switch
                          classes={{ switchBase: classes.switchBase }}
                          color="secondary"
                          checked={showLeaderboards}
                          onChange={() =>
                            window.parent.postMessage(
                              JSON.stringify({
                                showLeaderboards: !showLeaderboards,
                                event: "show-leaderboards",
                              }),
                              origin
                            )
                          }
                        />
                      </ListItem>
                    )}
                    <ListItem
                      button
                      onClick={() => setOpenCallHandling(!openCallHandling)}
                    >
                      <ListItemText
                        primary={
                          <Typography style={{ fontWeight: "bold" }}>
                            Call Handling
                          </Typography>
                        }
                      />
                      {openCallHandling ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse
                      in={openCallHandling}
                      timeout="auto"
                      unmountOnExit
                    >
                      {changeTab !== undefined && (
                        <List
                          component="div"
                          disablePadding
                          style={{ paddingLeft: 30 }}
                          classes={{ root: classes.list }}
                        >
                          <ListItem>
                            <ListItemText primary="Call Log Tab on Call" />
                          </ListItem>
                          <List
                            component="div"
                            disablePadding
                            style={{ paddingLeft: 30 }}
                            dense
                            classes={{ root: classes.list }}
                          >
                            <ListItem>
                              <ListItemText primary="Inbound" />

                              <Switch
                                classes={{ switchBase: classes.switchBase }}
                                color="secondary"
                                checked={
                                  changeTab === "Enabled" ||
                                  changeTab === "Inbound"
                                }
                                onClick={(event: any) => {
                                  let newValue;
                                  if (event.target.checked) {
                                    if (changeTab === "Disabled") {
                                      newValue = "Inbound";
                                    }

                                    if (changeTab === "Outbound") {
                                      newValue = "Enabled";
                                    }
                                  } else {
                                    if (changeTab === "Inbound") {
                                      newValue = "Disabled";
                                    }

                                    if (changeTab === "Enabled") {
                                      newValue = "Outbound";
                                    }
                                  }
                                  console.log(event, newValue);

                                  window.parent.postMessage(
                                    JSON.stringify({
                                      changeTab: newValue,
                                      event: "flip-on-call",
                                    }),
                                    origin
                                  );
                                }}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText primary="Outbound" />
                              <Switch
                                classes={{ switchBase: classes.switchBase }}
                                color="secondary"
                                checked={
                                  changeTab === "Enabled" ||
                                  changeTab === "Outbound"
                                }
                                onClick={(event: any) => {
                                  console.log(event);
                                  let newValue;
                                  if (event.target.checked) {
                                    if (changeTab === "Disabled") {
                                      newValue = "Outbound";
                                    }

                                    if (changeTab === "Inbound") {
                                      newValue = "Enabled";
                                    }
                                  } else {
                                    if (changeTab === "Outbound") {
                                      newValue = "Disabled";
                                    }

                                    if (changeTab === "Enabled") {
                                      newValue = "Inbound";
                                    }
                                  }

                                  window.parent.postMessage(
                                    JSON.stringify({
                                      changeTab: newValue,
                                      event: "flip-on-call",
                                    }),
                                    origin
                                  );
                                }}
                              />
                            </ListItem>
                          </List>
                        </List>
                      )}
                      {lastCode !== undefined && (
                        <List
                          component="div"
                          disablePadding
                          style={{ paddingLeft: 30, marginTop: 10 }}
                          classes={{ root: classes.list }}
                        >
                          <ListItem>
                            <ListItemText primary="Forced Account Codes" />
                          </ListItem>
                          <ListItem style={{ paddingLeft: 40 }}>
                            <FormControl>
                              <RadioGroup
                                value={lastCode}
                                onChange={(event) =>
                                  window.parent.postMessage(
                                    JSON.stringify({
                                      lastCode: event.target.value,
                                      event: "last-code",
                                    }),
                                    origin
                                  )
                                }
                              >
                                <FormControlLabel
                                  classes={{ label: classes.radioText }}
                                  style={{ paddingBottom: 10 }}
                                  value="No Suggestion"
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="No Suggestion"
                                />
                                <FormControlLabel
                                  style={{ paddingBottom: 10 }}
                                  classes={{ label: classes.radioText }}
                                  value="Suggest Last Code"
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="Suggest Last Code"
                                />
                                <FormControlLabel
                                  style={{ paddingBottom: 10 }}
                                  classes={{ label: classes.radioText }}
                                  value="Suggest Last Code for Number"
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="Suggest Last Code for Number"
                                />
                              </RadioGroup>
                            </FormControl>
                          </ListItem>
                        </List>
                      )}
                      {hasInvisibleCallControl && (
                        <List
                          component="div"
                          disablePadding
                          style={{ paddingLeft: 30, marginTop: 5 }}
                          classes={{ root: classes.list }}
                        >
                          <ListItem>
                            <ListItemText primary="When I am Invisible" />
                          </ListItem>

                          <ListItem style={{ paddingLeft: 40 }}>
                            <FormControl style={{ padding: 0 }}>
                              <RadioGroup
                                value={invisibleCallControl}
                                onChange={(event) => {
                                  const updateUser = async (newCallControl: string) => {
                                    setInvisibleCallControl(newCallControl);

                                    await fetch(
                                      forwardAddress.replace(
                                        "/shadow-agent",
                                        `/user/${rcId}`
                                      ),
                                      {
                                        method: "put",
                                        headers: {
                                          Authorization: idToken,
                                        },
                                        body: JSON.stringify({
                                          invisibleCallControl:
                                            newCallControl || undefined,
                                        }),
                                      }
                                    );
                                  };

                                  updateUser(event.target.value);
                                }}
                              >
                                <FormControlLabel
                                  style={{ paddingBottom: 10 }}
                                  classes={{ label: classes.radioText }}
                                  value=""
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="Take No Action"
                                />
                                <FormControlLabel
                                  style={{ paddingBottom: 10 }}
                                  classes={{ label: classes.radioText }}
                                  value="TakeAllCalls"
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="Take All Calls"
                                />
                                <FormControlLabel
                                  style={{ paddingBottom: 10 }}
                                  classes={{ label: classes.radioText }}
                                  value="DoNotAcceptDepartmentCalls"
                                  control={
                                    <Radio
                                      className={classes.radio}
                                      color="secondary"
                                      size="small"
                                      classes={{ root: classes.radioButton }}
                                    />
                                  }
                                  label="Do Not Accept Queue Calls"
                                />
                              </RadioGroup>
                            </FormControl>
                          </ListItem>
                        </List>
                      )}
                      {queueCallPickUp && (
                        <List
                          component="div"
                          disablePadding
                          style={{ paddingLeft: 30, marginTop: 5 }}
                          classes={{ root: classes.list }}
                        >
                          <ListItem>
                            <ListItemText primary="Cherry Pick" />
                            <Switch
                              classes={{ switchBase: classes.switchBase }}
                              color="secondary"
                              checked={!!showCherryPick}
                              onChange={() => {
                                setShowCherryPick(
                                  (oldShowCherryPick: boolean | undefined) =>
                                    !oldShowCherryPick
                                );
                              }}
                            />
                          </ListItem>
                          {/* <ListItem style={{ paddingLeft: 40 }}> */}
                          {/* <Grid container>
                            <Grid item xs={8} sm={6} md={3}>
                              <TextField value={deviceId || ""} />
                            </Grid>
                            <Grid>
                              <IconButton
                                color="inherit"
                                aria-label="delete"
                                style={{ margin: 5 }}
                                onClick={editDeviceId}
                                size="small"
                              >
                                <Edit />
                              </IconButton>
                            </Grid>
                            <Grid>
                              <IconButton
                                color="inherit"
                                aria-label="delete"
                                style={{ margin: 5 }}
                                onClick={deleteDeviceId}
                                size="small"
                              >
                                <Delete />
                              </IconButton>
                            </Grid>
                          </Grid> */}
                          {/* </ListItem> */}
                          {error !== undefined && (
                            <ListItem style={{ paddingLeft: 40 }}>
                              <ListItemText
                                style={{ color: "red" }}
                                primary={`${error}`}
                              />
                            </ListItem>
                          )}
                          {/* {myDevices && (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              if (deviceRef.current) {
                                changeDeviceId(deviceRef.current.value);
                              }
                            }}
                          >
                            <input type="text" ref={deviceRef} />
                            <button type="submit">Set Device</button>
                          </form>
                        )} */}
                          {myDevices && myDevices.length === 0 && (
                            <ListItem style={{ paddingLeft: 40 }}>
                              <ListItemText primary="You don't have any devices." />
                            </ListItem>
                          )}
                          {myDevices && myDevices.length > 0 && (
                            <ListItem style={{ paddingLeft: 40 }}>
                              <Grid container direction="column">
                                <Grid item>
                                  <FormControl style={{ padding: 0 }}>
                                    <RadioGroup
                                      value={deviceId}
                                      onChange={(e) => {
                                        // save to db
                                        changeDeviceId(e.target.value);
                                      }}
                                    >
                                      {myDevices.map((device) => (
                                        <FormControlLabel
                                          key={device.id}
                                          style={{ paddingBottom: 10 }}
                                          classes={{ label: classes.radioText }}
                                          value={device.id}
                                          control={
                                            <Radio
                                              className={classes.radio}
                                              color="secondary"
                                              size="small"
                                              classes={{
                                                root: classes.radioButton,
                                              }}
                                            />
                                          }
                                          label={
                                            <TableContainer component={Paper}>
                                              <Table
                                                className={classes.table}
                                                size="small"
                                                aria-label="a dense table"
                                                style={{
                                                  background:
                                                    mode === "light"
                                                      ? "white"
                                                      : "#333",
                                                  color:
                                                    mode === "light"
                                                      ? "black"
                                                      : "white",
                                                  borderRadius: 4,
                                                }}
                                              >
                                                <TableBody
                                                  style={{
                                                    border:
                                                      mode === "light"
                                                        ? "1px solid #cccccc"
                                                        : "1px solid #444444",
                                                  }}
                                                >
                                                  <TableRow
                                                    style={{
                                                      borderBottom:
                                                        "1px solid orange",
                                                    }}
                                                  >
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      Id
                                                    </TableCell>
                                                    <TableCell
                                                    className="notranslate"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                      align="right"
                                                    >
                                                      {device.id}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      Type
                                                    </TableCell>
                                                    <TableCell
                                                    className="notranslate"
                                                      align="right"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      {device.type || ""}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      Name
                                                    </TableCell>
                                                    <TableCell
                                                    className="notranslate"
                                                      align="right"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      <span className="notranslate">{device.name || ""}</span>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      Serial
                                                    </TableCell>
                                                    <TableCell
                                                    className="notranslate"
                                                      align="right"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      {device.serial || ""}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      Status
                                                    </TableCell>
                                                    <TableCell
                                                    className="notranslate"
                                                      align="right"
                                                      style={{
                                                        color:
                                                          mode === "light"
                                                            ? "black"
                                                            : "white",
                                                        borderBottom:
                                                          mode === "light"
                                                            ? ""
                                                            : "1px solid #444",
                                                      }}
                                                    >
                                                      {device.status || ""}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          }
                                        />
                                      ))}
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </ListItem>
                          )}
                        </List>
                      )}
                    </Collapse>
                  </Collapse>
                  <ListItem
                    button
                    style={{ marginTop: 10 }}
                    onClick={() => setOpenCX(!openCX)}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: "bold" }}>
                          CX
                        </Typography>
                      }
                      classes={{ root: classes.listItem }}
                    />
                    {openCX ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse
                    in={openCX}
                    style={{ marginLeft: 40 }}
                    unmountOnExit
                  >
                    <ListItem>
                      <ListItemText primary="Show Leaderboards" />
                      <Switch
                        classes={{ switchBase: classes.switchBase }}
                        color="secondary"
                        checked={showCXLeaderboards}
                        onChange={() => {
                          localStorage.setItem(
                            "cx-leaderboards-visible",
                            JSON.stringify(!showCXLeaderboards)
                          );
                          setShowCXLeaderboards((p: any) => !p);
                        }}
                      />
                    </ListItem>
                  </Collapse>
                </List>
              </Grid>
            </Grid>
          </StylesProvider>
        </ThemeProvider>
      ) : (
        <ThemeProvider theme={mode === "light" ? myTheme : darkTheme}>
          <StylesProvider generateClassName={generateClassName}>
            {/* <Dialog
          classes={{ paper: classes.dialog }}
          open={error !== undefined}
          fullWidth
          onClose={handleCloseError}
          aria-labelledby="error-waiting-tab"
        >
          {" "}
          <DialogTitle id="error-waiting-tab">Error</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography
                component="span"
                style={{ fontSize: "0.8rem" }}
                className={classes.typography}
              >
                {error}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleCloseError}
              color={mode === "dark" ? "default" : "primary"}
              variant="contained"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog> */}
            <Grid container spacing={0}>
              <Grid item sm={6} xs={12}>
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => setOpenDisplaySettings(!openDisplaySettings)}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: "bold" }}>
                          Display Settings
                        </Typography>
                      }
                      classes={{ root: classes.listItem }}
                    />
                    {openDisplaySettings ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse
                    in={openDisplaySettings}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 10 }}
                      dense
                      classes={{ root: classes.list }}
                    >
                      <ListItem>
                        <ListItemText primary="Dark Mode" />
                        <Switch
                          classes={{ switchBase: classes.switchBase }}
                          color="secondary"
                          checked={mode === "dark"}
                          onChange={() =>
                            setMode((prev: any) => {
                              localStorage.setItem(
                                "theme",
                                prev === "dark" ? "light" : "dark"
                              );
                              const dialerRef = document.querySelector(
                                "#ex-dialer"
                              ) as HTMLIFrameElement;
                              dialerRef?.contentWindow!.postMessage(
                                {
                                  type: "rc-adapter-theme-notify",
                                  theme: prev === "dark" ? "light" : "dark",
                                },
                                "*"
                              );
                              return prev === "dark" ? "light" : "dark";
                            })
                          }
                        />
                      </ListItem>
                      {showLeaderboards !== undefined && (
                        <ListItem>
                          <ListItemText primary="Show Leaderboards" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={showLeaderboards}
                            onChange={() =>
                              setShowLeaderboards((prev: any) => {
                                localStorage.setItem(
                                  `show-ex-leaderboards-${rcId}`,
                                  JSON.stringify(!prev)
                                );
                                return !prev;
                              })
                            }
                          />
                        </ListItem>
                      )}
                      {(orgId === "3154756020" || orgId === "1520397020" || orgId === "63002203008" )&& (
                        <ListItem>
                          <ListItemText primary="Display Legacy UI" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={legacyUI}
                            onChange={() => setLegacyUI((prev: any) => !prev)}
                          />
                        </ListItem>
                      )}
                      {/* <div id="settings_translate_element" /> */}
                      {hasPresenceTimer && (
                        <>
                          <ListItem>
                            <ListItemText primary="Elapsed Time Display" />
                          </ListItem>
                          <ListItem>
                            <FormControl style={{ paddingLeft: 10 }}>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={elapsedTime}
                                name="radio-buttons-group"
                                onChange={(e) => {
                                  setElapsedTime(() => {
                                    localStorage.setItem(
                                      `elapsed-time-display-${rcId}`,
                                      e.target.value
                                    );
                                    return e.target.value;
                                  });
                                }}
                              >
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="none"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      None
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="full"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      Full
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  className={classes.fontSize}
                                  value="approximate"
                                  control={<Radio className={classes.radio} />}
                                  label={
                                    <Typography
                                      style={{ fontSize: "0.875rem" }}
                                    >
                                      Approximate
                                    </Typography>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </ListItem>
                        </>
                      )}
                    </List>
                  </Collapse>
                  <ListItem
                    button
                    onClick={() => setOpenCallHandling(!openCallHandling)}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: "bold" }}>
                          Call Handling
                        </Typography>
                      }
                    />
                    {openCallHandling ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={openCallHandling} timeout="auto" unmountOnExit>
                    <List
                      component="div"
                      disablePadding
                      style={{ paddingLeft: 30 }}
                      classes={{ root: classes.list }}
                    >
                      <ListItem>
                        <ListItemText primary="Call Log Tab on Call" />
                      </ListItem>
                      <List
                        component="div"
                        disablePadding
                        style={{ paddingLeft: 30 }}
                        dense
                        classes={{ root: classes.list }}
                      >
                        <ListItem>
                          <ListItemText primary="Inbound" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={
                              changeTab === "Enabled" || changeTab === "Inbound"
                            }
                            onChange={(event: any) => {
                              let newValue = "Disabled";
                              if (event.target.checked) {
                                if (changeTab === "Disabled") {
                                  newValue = "Inbound";
                                }

                                if (changeTab === "Outbound") {
                                  newValue = "Enabled";
                                }
                              } else {
                                if (changeTab === "Inbound") {
                                  newValue = "Disabled";
                                }

                                if (changeTab === "Enabled") {
                                  newValue = "Outbound";
                                }
                              }
                              // Change tab here
                              setChangeTab(newValue);
                              localStorage.setItem("changeTab", newValue);
                            }}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemText primary="Outbound" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={
                              changeTab === "Enabled" ||
                              changeTab === "Outbound"
                            }
                            onChange={(event: any) => {
                              let newValue = "Disabled";
                              if (event.target.checked) {
                                if (changeTab === "Disabled") {
                                  newValue = "Outbound";
                                }

                                if (changeTab === "Inbound") {
                                  newValue = "Enabled";
                                }
                              } else {
                                if (changeTab === "Outbound") {
                                  newValue = "Disabled";
                                }

                                if (changeTab === "Enabled") {
                                  newValue = "Inbound";
                                }
                              }
                              // Change tab here
                              setChangeTab(newValue);
                              localStorage.setItem("changeTab", newValue);
                            }}
                          />
                        </ListItem>
                      </List>
                    </List>

                    {lastCode !== undefined && (
                      <List
                        component="div"
                        disablePadding
                        style={{ paddingLeft: 30, marginTop: 10 }}
                        classes={{ root: classes.list }}
                      >
                        <ListItem>
                          <ListItemText primary="Forced Account Codes" />
                        </ListItem>
                        <ListItem style={{ paddingLeft: 40 }}>
                          <FormControl>
                            <RadioGroup
                              value={lastCode}
                              onChange={(event) =>
                                window.parent.postMessage(
                                  JSON.stringify({
                                    lastCode: event.target.value,
                                    event: "last-code",
                                  }),
                                  origin
                                )
                              }
                            >
                              <FormControlLabel
                                classes={{ label: classes.radioText }}
                                style={{ paddingBottom: 10 }}
                                value="No Suggestion"
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="No Suggestion"
                              />
                              <FormControlLabel
                                style={{ paddingBottom: 10 }}
                                classes={{ label: classes.radioText }}
                                value="Suggest Last Code"
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="Suggest Last Code"
                              />
                              <FormControlLabel
                                style={{ paddingBottom: 10 }}
                                classes={{ label: classes.radioText }}
                                value="Suggest Last Code for Number"
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="Suggest Last Code for Number"
                              />
                            </RadioGroup>
                          </FormControl>
                        </ListItem>
                      </List>
                    )}
                    {hasInvisibleCallControl && (
                      <List
                        component="div"
                        disablePadding
                        style={{ paddingLeft: 30, marginTop: 5 }}
                        classes={{ root: classes.list }}
                      >
                        <ListItem>
                          <ListItemText primary="When I am Invisible" />
                        </ListItem>

                        <ListItem style={{ paddingLeft: 40 }}>
                          <FormControl style={{ padding: 0 }}>
                            <RadioGroup
                              value={invisibleCallControl}
                              onChange={(event) => {
                                const updateUser = async (
                                  newCallControl: string
                                ) => {
                                  setInvisibleCallControl(newCallControl || "");

                                  await fetch(
                                    forwardAddress.replace(
                                      "/shadow-agent",
                                      `/user/${rcId}`
                                    ),
                                    {
                                      method: "put",
                                      headers: {
                                        Authorization: idToken,
                                      },
                                      body: JSON.stringify({
                                        invisibleCallControl:
                                          newCallControl || "takeNoAction",
                                      }),
                                    }
                                  );
                                };
                                updateUser(event.target.value);
                              }}
                            >
                              <FormControlLabel
                                style={{ paddingBottom: 10 }}
                                classes={{ label: classes.radioText }}
                                value=""
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="Take No Action"
                              />
                              <FormControlLabel
                                style={{ paddingBottom: 10 }}
                                classes={{ label: classes.radioText }}
                                value="TakeAllCalls"
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="Take All Calls"
                              />
                              <FormControlLabel
                                style={{ paddingBottom: 10 }}
                                classes={{ label: classes.radioText }}
                                value="DoNotAcceptDepartmentCalls"
                                control={
                                  <Radio
                                    className={classes.radio}
                                    color="secondary"
                                    size="small"
                                    classes={{ root: classes.radioButton }}
                                  />
                                }
                                label="Do Not Accept Queue Calls"
                              />
                            </RadioGroup>
                          </FormControl>
                        </ListItem>
                      </List>
                    )}
                    {queueCallPickUp && (
                      <List
                        component="div"
                        disablePadding
                        style={{ paddingLeft: 30, marginTop: 5 }}
                        classes={{ root: classes.list }}
                      >
                        <ListItem>
                          <ListItemText primary="Cherry Pick" />
                          <Switch
                            classes={{ switchBase: classes.switchBase }}
                            color="secondary"
                            checked={!!showCherryPick}
                            onChange={() => {
                              setShowCherryPick(
                                (oldShowCherryPick: boolean | undefined) =>
                                  !oldShowCherryPick
                              );
                            }}
                          />
                        </ListItem>
                        {/* <ListItem style={{ paddingLeft: 40 }}> */}
                        {/* <Grid container>
                        <Grid item xs={8} sm={6} md={3}>
                          <TextField value={deviceId || ""} />
                        </Grid>
                        <Grid>
                          <IconButton
                            color="inherit"
                            aria-label="delete"
                            style={{ margin: 5 }}
                            onClick={editDeviceId}
                            size="small"
                          >
                            <Edit />
                          </IconButton>
                        </Grid>
                        <Grid>
                          <IconButton
                            color="inherit"
                            aria-label="delete"
                            style={{ margin: 5 }}
                            onClick={deleteDeviceId}
                            size="small"
                          >
                            <Delete />
                          </IconButton>
                        </Grid>
                      </Grid> */}
                        {/* </ListItem> */}
                        {error !== undefined && (
                          <ListItem style={{ paddingLeft: 40 }}>
                            <ListItemText
                              style={{ color: "red" }}
                              primary={`${error}`}
                            />
                          </ListItem>
                        )}
                        {/* {myDevices && (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (deviceRef.current) {
                            changeDeviceId(deviceRef.current.value);
                          }
                        }}
                      >
                        <input type="text" ref={deviceRef} />
                        <button type="submit">Set Device</button>
                      </form>
                    )} */}
                        {myDevices && myDevices.length === 0 && (
                          <ListItem style={{ paddingLeft: 40 }}>
                            <ListItemText primary="You don't have any devices." />
                          </ListItem>
                        )}
                        {myDevices && myDevices.length > 0 && (
                          <ListItem style={{ paddingLeft: 40 }}>
                            <Grid container direction="column">
                              <Grid item>
                                <FormControl style={{ padding: 0 }}>
                                  <RadioGroup
                                    value={deviceId}
                                    onChange={(e) => {
                                      // save to db
                                      changeDeviceId(e.target.value);
                                    }}
                                  >
                                    {myDevices.map((device) => (
                                      <FormControlLabel
                                        key={device.id}
                                        style={{ paddingBottom: 10 }}
                                        classes={{ label: classes.radioText }}
                                        value={device.id}
                                        control={
                                          <Radio
                                            className={classes.radio}
                                            color="secondary"
                                            size="small"
                                            classes={{
                                              root: classes.radioButton,
                                            }}
                                          />
                                        }
                                        label={
                                          <TableContainer component={Paper}>
                                            <Table
                                              className={classes.table}
                                              size="small"
                                              aria-label="a dense table"
                                              style={{
                                                background:
                                                  mode === "light"
                                                    ? "white"
                                                    : "#333",
                                                color:
                                                  mode === "light"
                                                    ? "black"
                                                    : "white",
                                                borderRadius: 4,
                                              }}
                                            >
                                              <TableBody
                                                style={{
                                                  border:
                                                    mode === "light"
                                                      ? "1px solid #cccccc"
                                                      : "1px solid #444444",
                                                }}
                                              >
                                                <TableRow
                                                  style={{
                                                    borderBottom:
                                                      "1px solid orange",
                                                  }}
                                                >
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    Id
                                                  </TableCell>
                                                  <TableCell
                                                  className="notranslate"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                    align="right"
                                                  >
                                                    {device.id}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    Type
                                                  </TableCell>
                                                  <TableCell
                                                    className="notranslate"
                                                    align="right"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    {device.type || ""}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    Name
                                                  </TableCell>
                                                  <TableCell
                                                  className="notranslate"
                                                    align="right"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    {device.name || ""}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                    component="th"
                                                    scope="row"
                                                  >
                                                    Serial
                                                  </TableCell>
                                                  <TableCell
                                                  className="notranslate"
                                                    align="right"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    {device.serial || ""}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                    component="th"
                                                    scope="row"
                                                  >
                                                    Status
                                                  </TableCell>
                                                  <TableCell
                                                  // className="notranslate"
                                                    align="right"
                                                    style={{
                                                      color:
                                                        mode === "light"
                                                          ? "black"
                                                          : "white",
                                                      borderBottom:
                                                        mode === "light"
                                                          ? ""
                                                          : "1px solid #444",
                                                    }}
                                                  >
                                                    {device.status || ""}
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        }
                                      />
                                    ))}
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </ListItem>
                        )}
                      </List>
                    )}
                  </Collapse>
                </List>
              </Grid>
            </Grid>
          </StylesProvider>
        </ThemeProvider>
      )}
    </>
}
// function Settings({
//   id,
//   origin,
//   mode,
//   rcId,
//   changeTab,
//   lastCode,
//   showLeaderboards,
//   elapsedTime,
//   setElapsedTime,
//   hasPresenceTimer,
//   hasInvisibleCallControl,
//   idToken,
//   forwardAddress,
//   showCherryPick,
//   deviceId,
//   rcAccessToken,
//   setDeviceId,
//   setShowCherryPick,
//   queueCallPickUp,
//   updateLocal,
// }: {
//   id: string;
//   origin: string;
//   mode: string;
//   rcId: string;
//   changeTab: string | undefined;
//   lastCode: string | undefined;
//   showLeaderboards: boolean | undefined;
//   elapsedTime: string;
//   setElapsedTime: any;
//   hasPresenceTimer: boolean;
//   hasInvisibleCallControl: boolean;
//   idToken: string;
//   forwardAddress: string;
//   showCherryPick: boolean | undefined;
//   deviceId: string | undefined;
//   rcAccessToken: string | undefined;
//   setDeviceId: any;
//   setShowCherryPick: any;
//   queueCallPickUp: boolean;
//   updateLocal: any;
// }) {
//   const [openDisplaySettings, setOpenDisplaySettings] = useState(false);
//   const [openCallHandling, setOpenCallHandling] = useState(false);
//   const [invisibleCallControl, setInvisibleCallControl] = useState<string>("");
//   // const [selectedDevice, setSelectedDevice] = useState<string | undefined>();
//   const [myDevices, setMyDevices] = useState<
//     | Array<{
//         id: string;
//         type?: string;
//         name?: string;
//         serial?: string;
//         status?: string;
//       }>
//     | undefined
//   >();
//   const [error, setError] = useState<string | undefined>();
//   const deviceRef = useRef<HTMLInputElement>(null);

//   const classes = mode === "light" ? useStyles() : useDarkStyles();
//   document.body.className = classes.body;

//   useEffect(() => {
//     if (elapsedTime === undefined) {
//       return;
//     }

//     updateLocal(`queue-summary-${id}-elapsedTime`, elapsedTime);
//   }, [elapsedTime]);

//   useEffect(() => {
//     if (!hasInvisibleCallControl) {
//       return;
//     }

//     (async () => {
//       const { invisibleCallControl: newCallControl } = (await fetch(
//         forwardAddress.replace("/shadow-agent", `/user/${rcId}`),
//         {
//           method: "get",
//           headers: {
//             Authorization: idToken,
//           },
//         }
//       ).then((res) => res.json())) as {
//         invisibleCallControl: string | undefined;
//       };

//       setInvisibleCallControl(newCallControl || "");
//     })();
//   }, [idToken]);

//   const getDeviceList = useCallback(async () => {
//     if (rcAccessToken === undefined) {
//       setError("No access token.");
//       return;
//     }
//     try {
//       const { records } = await fetch(
//         "https://platform.ringcentral.com/restapi/v1.0/account/~/extension/~/device",
//         {
//           method: "get",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${rcAccessToken}`,
//           },
//         }
//       ).then((response) => response.json());

//       setMyDevices(records);
//     } catch (err) {
//       console.log(err);
//       setError("Request Error. Please try again later.");
//     }
//   }, [rcAccessToken]);

//   useEffect(() => {
//     if (showCherryPick) {
//       return;
//     }

//     setMyDevices(undefined);
//   }, [showCherryPick]);

//   useEffect(() => {
//     if (showCherryPick !== true) {
//       return;
//     }
//     getDeviceList();
//   }, [showCherryPick]);

//   const changeDeviceId = useCallback(
//     async (selectedDevice) => {
//       if (selectedDevice !== deviceId) {
//         try {
//           const { status } = await fetch(
//             forwardAddress.replace("/shadow-agent", `/device/user/${rcId}`),
//             {
//               method: "put",
//               headers: {
//                 authorization: idToken,
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 deviceId: selectedDevice,
//               }),
//             }
//           );

//           if (status === 200) {
//             setDeviceId(selectedDevice);
//           } else {
//             throw Error();
//           }
//         } catch (err) {
//           setError("Couln't change device id. Please try again later.");
//         }
//       }
//     },
//     [deviceId, rcId, idToken]
//   );

//   useEffect(() => {
//     if (showCherryPick === undefined) {
//       return;
//     }

//     updateLocal(
//       `queue-summary-${id}-showCherryPick`,
//       showCherryPick.toString()
//     );
//   }, [showCherryPick, updateLocal]);

//   // const saveCherryPickPreference = useCallback(
//   //   async (newValue: boolean) => {
//   //     try {
//   //       const { status } = await fetch(
//   //         forwardAddress.replace("/shadow-agent", `/settings/user/${rcId}`),
//   //         {
//   //           method: "put",
//   //           headers: {
//   //             authorization: idToken,
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify({
//   //             key: "showCherryPick",
//   //             value: newValue,
//   //           }),
//   //         }
//   //       );

//   //       if (status === 200) {
//   //         setShowCherryPick(newValue);
//   //       } else {
//   //         throw Error();
//   //       }
//   //     } catch (err) {
//   //       setError("Something went wrong. Please try again.");
//   //     }
//   //   },
//   //   [rcId, idToken]
//   // );
//   // useEffect(() => {
//   //   if (selectedDevice === undefined) {
//   //     return;
//   //   }
//   //   saveDeviceId();
//   // }, [selectedDevice, saveDeviceId]);

//   // const handleCloseError = useCallback(() => setError(undefined), []);

//   return (
//     <ThemeProvider theme={mode === "light" ? myTheme : darkTheme}>
//       <StylesProvider generateClassName={generateClassName}>
//         {/* <Dialog
//           classes={{ paper: classes.dialog }}
//           open={error !== undefined}
//           fullWidth
//           onClose={handleCloseError}
//           aria-labelledby="error-waiting-tab"
//         >
//           {" "}
//           <DialogTitle id="error-waiting-tab">Error</DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               <Typography
//                 component="span"
//                 style={{ fontSize: "0.8rem" }}
//                 className={classes.typography}
//               >
//                 {error}
//               </Typography>
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button
//               autoFocus
//               onClick={handleCloseError}
//               color={mode === "dark" ? "default" : "primary"}
//               variant="contained"
//             >
//               OK
//             </Button>
//           </DialogActions>
//         </Dialog> */}
//         <Grid container spacing={0}>
//           <Grid item sm={6} xs={12}>
//             <List component="div" disablePadding>
//               <ListItem
//                 button
//                 onClick={() => setOpenDisplaySettings(!openDisplaySettings)}
//               >
//                 <ListItemText
//                   primary={
//                     <Typography style={{ fontWeight: "bold" }}>
//                       Display Settings
//                     </Typography>
//                   }
//                   classes={{ root: classes.listItem }}
//                 />
//                 {openDisplaySettings ? <ExpandLess /> : <ExpandMore />}
//               </ListItem>
//               <Collapse in={openDisplaySettings} timeout="auto" unmountOnExit>
//                 <List
//                   component="div"
//                   disablePadding
//                   style={{ paddingLeft: 10 }}
//                   dense
//                   classes={{ root: classes.list }}
//                 >
//                   <ListItem>
//                     <ListItemText primary="Dark Mode" />
//                     <Switch
//                       classes={{ switchBase: classes.switchBase }}
//                       color="secondary"
//                       checked={mode === "dark"}
//                       onChange={() =>
//                         window.parent.postMessage(
//                           JSON.stringify({
//                             theme: mode === "dark" ? "light" : "dark",
//                             event: "theme",
//                           }),
//                           origin
//                         )
//                       }
//                     />
//                   </ListItem>
//                   {showLeaderboards !== undefined && (
//                     <ListItem>
//                       <ListItemText primary="Show Leaderboards" />
//                       <Switch
//                         classes={{ switchBase: classes.switchBase }}
//                         color="secondary"
//                         checked={showLeaderboards}
//                         onChange={() =>
//                           window.parent.postMessage(
//                             JSON.stringify({
//                               showLeaderboards: !showLeaderboards,
//                               event: "show-leaderboards",
//                             }),
//                             origin
//                           )
//                         }
//                       />
//                     </ListItem>
//                   )}
//                   {hasPresenceTimer && (
//                     <>
//                       <ListItem>
//                         <ListItemText primary="Elapsed Time Display" />
//                       </ListItem>
//                       <ListItem>
//                         <FormControl style={{ paddingLeft: 10 }}>
//                           <RadioGroup
//                             aria-labelledby="demo-radio-buttons-group-label"
//                             value={elapsedTime}
//                             name="radio-buttons-group"
//                             onChange={(e) => {
//                               setElapsedTime(e.target.value);
//                             }}
//                           >
//                             <FormControlLabel
//                               className={classes.fontSize}
//                               value="none"
//                               control={<Radio className={classes.radio} />}
//                               label={
//                                 <Typography style={{ fontSize: "0.875rem" }}>
//                                   None
//                                 </Typography>
//                               }
//                             />
//                             <FormControlLabel
//                               className={classes.fontSize}
//                               value="full"
//                               control={<Radio className={classes.radio} />}
//                               label={
//                                 <Typography style={{ fontSize: "0.875rem" }}>
//                                   Full
//                                 </Typography>
//                               }
//                             />
//                             <FormControlLabel
//                               className={classes.fontSize}
//                               value="approximate"
//                               control={<Radio className={classes.radio} />}
//                               label={
//                                 <Typography style={{ fontSize: "0.875rem" }}>
//                                   Approximate
//                                 </Typography>
//                               }
//                             />
//                           </RadioGroup>
//                         </FormControl>
//                       </ListItem>
//                     </>
//                   )}
//                 </List>
//               </Collapse>
//               <ListItem
//                 button
//                 onClick={() => setOpenCallHandling(!openCallHandling)}
//               >
//                 <ListItemText
//                   primary={
//                     <Typography style={{ fontWeight: "bold" }}>
//                       Call Handling
//                     </Typography>
//                   }
//                 />
//                 {openCallHandling ? <ExpandLess /> : <ExpandMore />}
//               </ListItem>
//               <Collapse in={openCallHandling} timeout="auto" unmountOnExit>
//                 {changeTab !== undefined && (
//                   <List
//                     component="div"
//                     disablePadding
//                     style={{ paddingLeft: 30 }}
//                     classes={{ root: classes.list }}
//                   >
//                     <ListItem>
//                       <ListItemText primary="Call Log Tab on Call" />
//                     </ListItem>
//                     <List
//                       component="div"
//                       disablePadding
//                       style={{ paddingLeft: 30 }}
//                       dense
//                       classes={{ root: classes.list }}
//                     >
//                       <ListItem>
//                         <ListItemText primary="Inbound" />
//                         <Switch
//                           classes={{ switchBase: classes.switchBase }}
//                           color="secondary"
//                           checked={
//                             changeTab === "Enabled" || changeTab === "Inbound"
//                           }
//                           onChange={(event: any) => {
//                             let newValue;
//                             if (event.target.checked) {
//                               if (changeTab === "Disabled") {
//                                 newValue = "Inbound";
//                               }

//                               if (changeTab === "Outbound") {
//                                 newValue = "Enabled";
//                               }
//                             } else {
//                               if (changeTab === "Inbound") {
//                                 newValue = "Disabled";
//                               }

//                               if (changeTab === "Enabled") {
//                                 newValue = "Outbound";
//                               }
//                             }

//                             window.parent.postMessage(
//                               JSON.stringify({
//                                 changeTab: newValue,
//                                 event: "flip-on-call",
//                               }),
//                               origin
//                             );
//                           }}
//                         />
//                       </ListItem>
//                       <ListItem>
//                         <ListItemText primary="Outbound" />
//                         <Switch
//                           classes={{ switchBase: classes.switchBase }}
//                           color="secondary"
//                           checked={
//                             changeTab === "Enabled" || changeTab === "Outbound"
//                           }
//                           onChange={(event: any) => {
//                             let newValue;
//                             if (event.target.checked) {
//                               if (changeTab === "Disabled") {
//                                 newValue = "Outbound";
//                               }

//                               if (changeTab === "Inbound") {
//                                 newValue = "Enabled";
//                               }
//                             } else {
//                               if (changeTab === "Outbound") {
//                                 newValue = "Disabled";
//                               }

//                               if (changeTab === "Enabled") {
//                                 newValue = "Inbound";
//                               }
//                             }

//                             window.parent.postMessage(
//                               JSON.stringify({
//                                 changeTab: newValue,
//                                 event: "flip-on-call",
//                               }),
//                               origin
//                             );
//                           }}
//                         />
//                       </ListItem>
//                     </List>
//                   </List>
//                 )}
//                 {lastCode !== undefined && (
//                   <List
//                     component="div"
//                     disablePadding
//                     style={{ paddingLeft: 30, marginTop: 10 }}
//                     classes={{ root: classes.list }}
//                   >
//                     <ListItem>
//                       <ListItemText primary="Forced Account Codes" />
//                     </ListItem>
//                     <ListItem style={{ paddingLeft: 40 }}>
//                       <FormControl>
//                         <RadioGroup
//                           value={lastCode}
//                           onChange={(event) =>
//                             window.parent.postMessage(
//                               JSON.stringify({
//                                 lastCode: event.target.value,
//                                 event: "last-code",
//                               }),
//                               origin
//                             )
//                           }
//                         >
//                           <FormControlLabel
//                             classes={{ label: classes.radioText }}
//                             style={{ paddingBottom: 10 }}
//                             value="No Suggestion"
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="No Suggestion"
//                           />
//                           <FormControlLabel
//                             style={{ paddingBottom: 10 }}
//                             classes={{ label: classes.radioText }}
//                             value="Suggest Last Code"
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="Suggest Last Code"
//                           />
//                           <FormControlLabel
//                             style={{ paddingBottom: 10 }}
//                             classes={{ label: classes.radioText }}
//                             value="Suggest Last Code for Number"
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="Suggest Last Code for Number"
//                           />
//                         </RadioGroup>
//                       </FormControl>
//                     </ListItem>
//                   </List>
//                 )}
//                 {hasInvisibleCallControl && (
//                   <List
//                     component="div"
//                     disablePadding
//                     style={{ paddingLeft: 30, marginTop: 5 }}
//                     classes={{ root: classes.list }}
//                   >
//                     <ListItem>
//                       <ListItemText primary="When I am Invisible" />
//                     </ListItem>

//                     <ListItem style={{ paddingLeft: 40 }}>
//                       <FormControl style={{ padding: 0 }}>
//                         <RadioGroup
//                           value={invisibleCallControl}
//                           onChange={(event) => {
//                             const updateUser = async (
//                               newCallControl: string
//                             ) => {
//                               setInvisibleCallControl(newCallControl);

//                               await fetch(
//                                 forwardAddress.replace(
//                                   "/shadow-agent",
//                                   `/user/${rcId}`
//                                 ),
//                                 {
//                                   method: "put",
//                                   headers: {
//                                     Authorization: idToken,
//                                   },
//                                   body: JSON.stringify({
//                                     invisibleCallControl:
//                                       newCallControl || undefined,
//                                   }),
//                                 }
//                               );
//                             };

//                             updateUser(event.target.value);
//                           }}
//                         >
//                           <FormControlLabel
//                             style={{ paddingBottom: 10 }}
//                             classes={{ label: classes.radioText }}
//                             value=""
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="Take No Action"
//                           />
//                           <FormControlLabel
//                             style={{ paddingBottom: 10 }}
//                             classes={{ label: classes.radioText }}
//                             value="TakeAllCalls"
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="Take All Calls"
//                           />
//                           <FormControlLabel
//                             style={{ paddingBottom: 10 }}
//                             classes={{ label: classes.radioText }}
//                             value="DoNotAcceptDepartmentCalls"
//                             control={
//                               <Radio
//                                 className={classes.radio}
//                                 color="secondary"
//                                 size="small"
//                                 classes={{ root: classes.radioButton }}
//                               />
//                             }
//                             label="Do Not Accept Queue Calls"
//                           />
//                         </RadioGroup>
//                       </FormControl>
//                     </ListItem>
//                   </List>
//                 )}
//                 {queueCallPickUp && (
//                   <List
//                     component="div"
//                     disablePadding
//                     style={{ paddingLeft: 30, marginTop: 5 }}
//                     classes={{ root: classes.list }}
//                   >
//                     <ListItem>
//                       <ListItemText primary="Cherry Pick" />
//                       <Switch
//                         classes={{ switchBase: classes.switchBase }}
//                         color="secondary"
//                         checked={!!showCherryPick}
//                         onChange={() => {
//                           setShowCherryPick(
//                             (oldShowCherryPick: boolean | undefined) =>
//                               !oldShowCherryPick
//                           );
//                         }}
//                       />
//                     </ListItem>
//                     {/* <ListItem style={{ paddingLeft: 40 }}> */}
//                     {/* <Grid container>
//                         <Grid item xs={8} sm={6} md={3}>
//                           <TextField value={deviceId || ""} />
//                         </Grid>
//                         <Grid>
//                           <IconButton
//                             color="inherit"
//                             aria-label="delete"
//                             style={{ margin: 5 }}
//                             onClick={editDeviceId}
//                             size="small"
//                           >
//                             <Edit />
//                           </IconButton>
//                         </Grid>
//                         <Grid>
//                           <IconButton
//                             color="inherit"
//                             aria-label="delete"
//                             style={{ margin: 5 }}
//                             onClick={deleteDeviceId}
//                             size="small"
//                           >
//                             <Delete />
//                           </IconButton>
//                         </Grid>
//                       </Grid> */}
//                     {/* </ListItem> */}
//                     {error !== undefined && (
//                       <ListItem style={{ paddingLeft: 40 }}>
//                         <ListItemText
//                           style={{ color: "red" }}
//                           primary={`${error}`}
//                         />
//                       </ListItem>
//                     )}
//                     {/* {myDevices && (
//                       <form
//                         onSubmit={(e) => {
//                           e.preventDefault();
//                           if (deviceRef.current) {
//                             changeDeviceId(deviceRef.current.value);
//                           }
//                         }}
//                       >
//                         <input type="text" ref={deviceRef} />
//                         <button type="submit">Set Device</button>
//                       </form>
//                     )} */}
//                     {myDevices && myDevices.length === 0 && (
//                       <ListItem style={{ paddingLeft: 40 }}>
//                         <ListItemText primary="You don't have any devices." />
//                       </ListItem>
//                     )}
//                     {myDevices && myDevices.length > 0 && (
//                       <ListItem style={{ paddingLeft: 40 }}>
//                         <Grid container direction="column">
//                           <Grid item>
//                             <FormControl style={{ padding: 0 }}>
//                               <RadioGroup
//                                 value={deviceId}
//                                 onChange={(e) => {
//                                   // save to db
//                                   changeDeviceId(e.target.value);
//                                 }}
//                               >
//                                 {myDevices.map((device) => (
//                                   <FormControlLabel
//                                     key={device.id}
//                                     style={{ paddingBottom: 10 }}
//                                     classes={{ label: classes.radioText }}
//                                     value={device.id}
//                                     control={
//                                       <Radio
//                                         className={classes.radio}
//                                         color="secondary"
//                                         size="small"
//                                         classes={{ root: classes.radioButton }}
//                                       />
//                                     }
//                                     label={
//                                       <TableContainer component={Paper}>
//                                         <Table
//                                           className={classes.table}
//                                           size="small"
//                                           aria-label="a dense table"
//                                           style={{
//                                             background:
//                                               mode === "light"
//                                                 ? "white"
//                                                 : "#333",
//                                             color:
//                                               mode === "light"
//                                                 ? "black"
//                                                 : "white",
//                                             borderRadius: 4,
//                                           }}
//                                         >
//                                           <TableBody
//                                             style={{
//                                               border:
//                                                 mode === "light"
//                                                   ? "1px solid #cccccc"
//                                                   : "1px solid #444444",
//                                             }}
//                                           >
//                                             <TableRow
//                                               style={{
//                                                 borderBottom:
//                                                   "1px solid orange",
//                                               }}
//                                             >
//                                               <TableCell
//                                                 component="th"
//                                                 scope="row"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 Id
//                                               </TableCell>
//                                               <TableCell
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                                 align="right"
//                                               >
//                                                 {device.id}
//                                               </TableCell>
//                                             </TableRow>
//                                             <TableRow>
//                                               <TableCell
//                                                 component="th"
//                                                 scope="row"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 Type
//                                               </TableCell>
//                                               <TableCell
//                                                 align="right"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 {device.type || ""}
//                                               </TableCell>
//                                             </TableRow>
//                                             <TableRow>
//                                               <TableCell
//                                                 component="th"
//                                                 scope="row"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 Name
//                                               </TableCell>
//                                               <TableCell
//                                                 align="right"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 {device.name || ""}
//                                               </TableCell>
//                                             </TableRow>
//                                             <TableRow>
//                                               <TableCell
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                                 component="th"
//                                                 scope="row"
//                                               >
//                                                 Serial
//                                               </TableCell>
//                                               <TableCell
//                                                 align="right"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 {device.serial || ""}
//                                               </TableCell>
//                                             </TableRow>
//                                             <TableRow>
//                                               <TableCell
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                                 component="th"
//                                                 scope="row"
//                                               >
//                                                 Status
//                                               </TableCell>
//                                               <TableCell
//                                                 align="right"
//                                                 style={{
//                                                   color:
//                                                     mode === "light"
//                                                       ? "black"
//                                                       : "white",
//                                                   borderBottom:
//                                                     mode === "light"
//                                                       ? ""
//                                                       : "1px solid #444",
//                                                 }}
//                                               >
//                                                 {device.status || ""}
//                                               </TableCell>
//                                             </TableRow>
//                                           </TableBody>
//                                         </Table>
//                                       </TableContainer>
//                                     }
//                                   />
//                                 ))}
//                               </RadioGroup>
//                             </FormControl>
//                           </Grid>
//                         </Grid>
//                       </ListItem>
//                     )}
//                   </List>
//                 )}
//               </Collapse>
//             </List>
//           </Grid>
//         </Grid>
//       </StylesProvider>
//     </ThemeProvider>
//   );
// }

export default Settings;
